import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-data-partner',
  templateUrl: './data-partner.component.html',
  styleUrls: ['./data-partner.component.scss']
})
export class DataPartnerComponent implements OnInit {

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {


  }

}
